<div class="app-container">
  <page-header [icon]="'fa-file-check'" [title]="'inventoryExports'">
    <ng-container class="header-button">
      <modal-print-export
        *ngIf="hasRoleInventoryCreate"
        [exportType]="'inventory-exports'"
        (resultExport)="createExportInventory($event)"
        data-cy="add-inventory"
      ></modal-print-export>
    </ng-container>
  </page-header>

  <section class="content">
    <div class="container-fluid pl-0 pr-0">
      <app-base-listing
        [storageKey]="storageKey"
        [loadingNextItems]="loading"
        [loadingItems]="reloading"
        [items]="reports"
        [columns]="listingColumns"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [endPage]="endPage"
        [(sortProp)]="filters.sortProp"
        [(sortDir)]="filters.sortDir"
        (reloadList)="filter(1)"
        (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
        (callAction)="callAction($event)"
      ></app-base-listing>
    </div>
  </section>
</div>
